export const FILES_COLLECTION_NAME: string = "directus_files";

export enum ItemFileMetadataKeys {
  IS_UPLOADED = "isUploaded",
  FILE_DATA = "fileData",
}
